import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest
} from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
// import { environment } from '../../../environments/environment';
import { LocalStorageService } from './localstorage.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor(public localStorageService: LocalStorageService) {}
    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        if (request.url.indexOf('https://tax-api') === -1) {
            return next.handle(request);
        }

        let token = this.localStorageService.loadInfo('token');
        let tenant = this.localStorageService.loadInfo('tenant');
        if (!token) {
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.get('accessToken')) {
                token = urlParams.get('accessToken');
            }
        }

        const headers = {
            Authorization: `Bearer ${token}`
        };

        if (tenant) {
            headers['x-tenant'] = tenant;
        }

        request = request.clone({
            setHeaders: headers
        });

        return next.handle(request);
    }
}
